import { inject, injectable } from "inversify";
import type { ApiResponse } from "../models/response.model";
import axios from "axios";
import TokenRepo from "./token.repo";

const BASE_URL = process.env.REACT_APP_API_URL;
const NGROK = (process.env.REACT_APP_API_NGROK === "true"?{"ngrok-skip-browser-warning": "true"}:{})

@injectable()
export default class ApiRepo {

  @inject(TokenRepo)
  private tokenRepo!: TokenRepo;

  async get<T>(path: string, params?: object, useToken = true): Promise<ApiResponse<T> | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token&&useToken) {
        result = await axios.get(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token,
          ...NGROK
        }});
      } else {
        result = await axios.get(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json", ...NGROK}});
      }
      return result.data as ApiResponse<T>;
    } catch (err) {
      console.log(err);
    }
  }

  async getBlob(path: string, params?: object, useToken = true): Promise<string | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token&&useToken) {
        result = await axios.get(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json", "Authorization": "Bearer " + token}, responseType: "blob"},)
      } else {
        result = await axios.get(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json"}, responseType: "blob"});
      }
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }

  async post<T>(path: string, body?: object, params?: object, useToken = true ): Promise<ApiResponse<T> | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token&&useToken) {
        result = await axios.post(BASE_URL + path, body, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json", "Authorization": "Bearer " + token}})
      } else {
        result = await axios.post(BASE_URL + path, body, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json"}})
      }
      return result.data as ApiResponse<T>;
    } catch (err) {
      console.log(err);
    }
  }

  async postMultipart<T>(path: string, formData: FormData, params?: object, useToken = true): Promise<ApiResponse<T> | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token && useToken) {
        result = await axios.post(BASE_URL + path, formData, {
          params: { v: "1.0", ...params },
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": "Bearer " + token
          }
        });
      } else {
        result = await axios.post(BASE_URL + path, formData, {
          params: { v: "1.0", ...params },
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      }
      return result.data as ApiResponse<T>;
    } catch (err) {
      console.log(err);
    }
  }

  async patch<T>(path: string, body?: object, params?: object, useToken = true): Promise<ApiResponse<T> | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token&&useToken) {
        result = await axios.patch(BASE_URL + path, body, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json", "Authorization": "Bearer " + token}})
      } else {
        result = await axios.patch(BASE_URL + path, body, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json"}})
      }
      return result.data as ApiResponse<T>;
    } catch (err) {
      console.log(err);
    }
  }

  async delete<T>(path: string, params?: object, useToken = true): Promise<ApiResponse<T> | undefined> {
    try {
      const token = this.tokenRepo.getToken();
      let result;
      if (token&&useToken) {
        result = await axios.delete(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json", "Authorization": "Bearer " + token}})
      } else {
        result = await axios.delete(BASE_URL + path, {params: {v: "1.0", ...params}, headers: {"Content-Type": "application/json"}})
      }
      return result.data as ApiResponse<T>;
    } catch (err) {
      console.log(err);
    }
  }
}